module.exports = __webpack_public_path__ + "img/iso.6cf8ccad.png";